import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminContacts() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/contact").then(({ data }) => setItems(data.items));
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try { await api.patch(`/admin/contact/${id}`, { status }); toast.success(`Marked ${status}`); load(); } catch { toast.error("Failed"); }
    };

    return (
        <div data-testid="admin-contacts">
            <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Inbox</div>
            <h1 className="mt-1 font-display text-4xl uppercase italic text-[hsl(var(--ink))]">Contact messages</h1>
            <div className="mt-6 space-y-3">
                {items.length === 0 && (
                    <div className="border-2 border-dashed border-[hsl(var(--dust-300))] p-8 text-center text-[hsl(var(--ink-soft))]">No messages yet.</div>
                )}
                {items.map((m) => (
                    <div key={m.id} className={`border-2 border-[hsl(var(--ink))] bg-card p-5 ${m.status === "handled" ? "opacity-60" : ""}`}>
                        <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                                <div className="font-heading text-base uppercase text-[hsl(var(--ink))]">{m.name}</div>
                                <div className="font-mono-brand text-xs text-[hsl(var(--ink-soft))]">{m.email} · {m.subject} · {new Date(m.created_at).toLocaleString()}</div>
                                {m.rig && <div className="font-mono-brand text-xs text-[hsl(var(--forest))]">rig: {m.rig}</div>}
                            </div>
                            <div className="flex gap-2">
                                <span className="border border-[hsl(var(--ink))] px-2 py-1 font-mono-brand text-[10px] uppercase">{m.status}</span>
                                {m.status !== "handled" && <button onClick={() => setStatus(m.id, "handled")} className="border border-[hsl(var(--success))] px-3 py-1 font-heading text-xs uppercase tracking-wider text-[hsl(var(--success))]">Mark handled</button>}
                                {m.status === "handled" && <button onClick={() => setStatus(m.id, "new")} className="border border-[hsl(var(--ink))] px-3 py-1 font-heading text-xs uppercase tracking-wider">Reopen</button>}
                            </div>
                        </div>
                        <p className="mt-3 whitespace-pre-wrap text-sm text-[hsl(var(--ink))]">{m.message}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
